import deDe from './deDe.json'
import enUs from './enUs.json'
import esEs from './esEs.json'
import frFr from './frFr.json'
import itIt from './itIt.json'
import ptBr from './ptBr.json'

export default {
  deDe,
  enUs,
  esEs,
  frFr,
  itIt,
  ptBr,
}
